import HomePage from 'components/pages/HomePage';
import { alternatesFor } from 'i18n';
import { softwareApplication } from 'utils/jsonld';

const Home = () => <HomePage />;

export const getStaticProps = () => ({
  props: {
    locale: 'en',
    meta: {
      title: 'Address autocomplete API, 10k free requests/month',
      description:
        'Address autocomplete and geocoding API, worldwide and fast, built by ex-Algolia engineers. 10,000 free requests a month, then pay per request.',
      alternates: alternatesFor('/'),
      jsonLd: [softwareApplication()],
    },
  },
});

export default Home;
